/*
 * jQuery.fn.visible polyfill
 * Minimal viewport visibility checker used by theme scripts.
 * If a version already exists, this will not override it.
 */
(function(factory){
  if (typeof window !== 'undefined') {
    factory(window.jQuery || window.Zepto);
  }
})(function($){
  if (!$ || $.fn.visible) return; // Do not override if already provided

  $.fn.visible = function(partial, hidden, direction, container){
    // partial: when true, element is considered visible if it intersects the viewport
    // hidden: when true, also require the element to be :visible in the DOM
    // direction and container are accepted for API compatibility but minimally handled
    if (!this || this.length < 1) return false;

    var $t = this.eq(0);
    var $c = container ? $(container) : $(window);

    // If container is not found, fall back to window
    if ($c.length === 0) $c = $(window);

    var cTop, cBottom, cLeft, cRight;
    var tTop, tBottom, tLeft, tRight;

    if ($c[0] === window) {
      cTop = $c.scrollTop();
      cLeft = $c.scrollLeft();
      cBottom = cTop + $c.height();
      cRight = cLeft + $c.width();
    } else {
      var cOffset = $c.offset();
      cTop = cOffset.top;
      cLeft = cOffset.left;
      cBottom = cTop + $c.innerHeight();
      cRight = cLeft + $c.innerWidth();
    }

    var tOffset = $t.offset();
    tTop = tOffset.top;
    tLeft = tOffset.left;
    tBottom = tTop + $t.outerHeight();
    tRight = tLeft + $t.outerWidth();

    var verticallyVisible = partial ? (tBottom >= cTop && tTop <= cBottom) : (tTop >= cTop && tBottom <= cBottom);
    var horizontallyVisible = partial ? (tRight >= cLeft && tLeft <= cRight) : (tLeft >= cLeft && tRight <= cRight);

    var vis;
    // Basic support for direction arg: 'both' (default), 'vertical', 'horizontal'
    if (direction === 'vertical') {
      vis = verticallyVisible;
    } else if (direction === 'horizontal') {
      vis = horizontallyVisible;
    } else {
      vis = verticallyVisible && horizontallyVisible;
    }

    if (hidden === true) {
      vis = vis && $t.is(':visible');
    }

    return vis;
  };
});
